import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { isAssessmentArmed, stashPendingLeave } from "../leaveSignal";

// -- App-level bounce-back for /start-assessment. ----------------------------
// This SPA uses <BrowserRouter>, so useBlocker() does not exist here (it needs
// a data router) and swallowing history.pushState does not stop the router:
// @remix-run/router computes its own next location and notifies its listener
// regardless. The practical pattern is therefore to LET the navigation happen,
// notice it in THIS component (it is rendered beside the <Routes>, so it stays
// mounted when /start-assessment unmounts), record where the therapist was
// heading, and bounce straight back to the assessment URL.
//
// StartAssessment then finds the stashed destination in localStorage, opens
// the same Save-for-Later popup ("save this incomplete session or delete it"),
// and only leaves for real once the therapist has made that choice.
const AssessmentLeaveGuard = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const prevRef = useRef({ pathname: location.pathname, search: location.search, hash: location.hash });

  useEffect(() => {
    const prev = prevRef.current;
    const cur = { pathname: location.pathname, search: location.search, hash: location.hash };

    if (prev.pathname === "/start-assessment" && cur.pathname !== "/start-assessment") {
      if (isAssessmentArmed()) {
        stashPendingLeave(cur.pathname + cur.search + cur.hash, prev.pathname + prev.search + prev.hash);
        navigate(prev.pathname + prev.search + prev.hash, { replace: true });
        return; // keep prev: the revert is not a new destination
      }
    }
    prevRef.current = cur;
  }, [location, navigate]);

  return null;
};

export default AssessmentLeaveGuard;